export const LINKS = {
  eula: 'https://www.k-motion.com/eula/',
  termsOfUse: 'https://www.k-motion.com/terms-of-use/',
  privacyPolicy: 'https://www.k-motion.com/privacy-policy'
};
